(() => {
  if (window.__BT_FreeShipBoundV4) return;
  window.__BT_FreeShipBoundV4 = true;

  const ROOT_ID = 'product-freeshipping-bar';
  const CONTAINER_ID = 'product-freeshipping-container';
  const PROMO_ROOT_SELECTOR = '[data-freeshipping-bar]';
  const PROMO_CONTAINER_SELECTOR = '[data-freeshipping-container]';
  const BAR_SELECTOR = '.free-offer-bar, [data-freeshipping-fill]';
  const REFRESH_DELAY = 150;

  let lastCartSig = null;
  let refreshTimer = null;
  let refreshInFlight = false;
  let observer = null;

  // Helper to ensure paths include shopify root routing (safeguards local ports)
  function getShopifyRoute(path) {
    const root = window.Shopify?.routes?.root || '/';
    return `${root.replace(/\/$/, '')}/${path.replace(/^\//, '')}`;
  }

  function getRoot() { return document.getElementById(ROOT_ID); }
  function getContainer() { return document.getElementById(CONTAINER_ID); }
  function getContainers() {
    return [
      ...document.querySelectorAll(`#${CONTAINER_ID}, ${PROMO_CONTAINER_SELECTOR}`)
    ];
  }
  function getRoots() {
    return [
      ...document.querySelectorAll(`#${ROOT_ID}, ${PROMO_ROOT_SELECTOR}`)
    ];
  }
  function getBar(root = getRoot()) { return root?.querySelector(BAR_SELECTOR) || null; }

  function getBarTargetWidth(bar) {
    if (!bar) return null;
    const target = parseFloat(bar.dataset.currentWidth || '0');
    return Number.isNaN(target) ? null : target;
  }

  function prepareBarForAnimation(root, bar) {
    const target = getBarTargetWidth(bar);
    if (!root || !bar || target === null) return null;
    root.setAttribute('data-animated', '1');
    bar.style.transition = 'none';
    bar.style.width = '0%';
    void bar.offsetWidth;
    return target;
  }

  function animateBar(root = getRoot()) {
    const bar = getBar(root);
    const target = prepareBarForAnimation(root, bar);
    if (target === null) return;
    requestAnimationFrame(() => {
      bar.style.transition = 'width 700ms ease-in-out';
      bar.style.width = `${target}%`;
    });
  }

  function setBarImmediately(root = getRoot()) {
    const bar = getBar(root);
    const target = getBarTargetWidth(bar);
    if (!root || !bar || target === null) return;
    root.setAttribute('data-animated', '1');
    bar.style.transition = 'none';
    bar.style.width = `${target}%`;
    requestAnimationFrame(() => {
      bar.style.transition = 'width 700ms ease-in-out';
    });
  }

  function initBar(root = getRoot(), { animate = true } = {}) {
    if (!root) return;
    if (animate) {
      animateBar(root);
    } else {
      setBarImmediately(root);
    }
  }

  async function getCartSignature() {
    // FIX 1: Use safe localized path for cart.js fetch
    const response = await fetch(getShopifyRoute('cart.js'), { 
      headers: { 'X-Requested-With': 'XMLHttpRequest' } 
    });
    if (!response.ok) return null;
    const cart = await response.json();
    return `${cart.item_count}|${cart.items_subtotal_price}|${cart.total_price}`;
  }

  async function fetchFreshSectionHTML(sectionId) {
    // FIX 2: Create URL safely using window.location.origin to keep the exact current port (:9292)
    const url = new URL(window.location.pathname, window.location.origin);
    url.searchParams.set('sections', sectionId);
    
    const response = await fetch(url.toString(), { 
      headers: { 'X-Requested-With': 'XMLHttpRequest' } 
    });
    if (!response.ok) return null;
    const json = await response.json();
    return json?.[sectionId] || null;
  }

  async function refreshFromPageHTML() {
    const currentContainers = getContainers();
    if (!currentContainers.length) return;

    const cartSig = await getCartSignature();
    if (cartSig && cartSig === lastCartSig) return;
    if (cartSig) lastCartSig = cartSig;

    const sectionHtml = new Map();
    for (const currentContainer of currentContainers) {
      const sectionId = currentContainer.dataset.sectionId;
      if (!sectionId) continue;
      if (!sectionHtml.has(sectionId)) {
        sectionHtml.set(sectionId, await fetchFreshSectionHTML(sectionId));
      }
      const html = sectionHtml.get(sectionId);
      if (!html) continue;

      const doc = new DOMParser().parseFromString(html, 'text/html');
      const componentId = currentContainer.dataset.componentId;
      const freshContainer = componentId
        ? doc.querySelector(`${PROMO_CONTAINER_SELECTOR}[data-component-id="${componentId}"]`)
        : doc.getElementById(CONTAINER_ID);
      if (!freshContainer) continue;

      currentContainer.replaceWith(freshContainer);
      initBar(freshContainer.querySelector(`#${ROOT_ID}, ${PROMO_ROOT_SELECTOR}`), { animate: true });
    }
  }

  function scheduleRefresh() {
    if (refreshTimer) clearTimeout(refreshTimer);
    refreshTimer = setTimeout(async () => {
      if (refreshInFlight) return;
      refreshInFlight = true;
      try {
        await refreshFromPageHTML();
      } catch (error) {
        console.error('[BT Free Shipping Bar] Refresh failed:', error);
      } finally {
        refreshInFlight = false;
      }
    }, REFRESH_DELAY);
  }

  function watchForRootReplacement() {
    if (observer) observer.disconnect();
    observer = new MutationObserver(() => {
      getRoots().forEach((root) => {
        if (!root.dataset.btInitialized) {
          root.dataset.btInitialized = 'true';
          initBar(root, { animate: true });
        }
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });

    getRoots().forEach((root) => {
      if (!root.dataset.btInitialized) {
        root.dataset.btInitialized = 'true';
        initBar(root, { animate: true });
      }
    });
  }

  document.addEventListener('eurus:cart:items-changed', scheduleRefresh);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      watchForRootReplacement();
    });
  } else {
    watchForRootReplacement();
  }
})();
